import { AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API,
  headers: { 'Content-Type': 'application/json' },
  responseType: 'json',
};

export default config;
